import React from 'react';
import CustomButton from '../../v2/general/CustomButton/CustomButton';

interface SchedulesManageScheduleButtonProps {
  onClick?: () => void;
}

/**
 * ## SchedulesManageScheduleButton component
 * Button component for opening the Manage Schedule drawer.
 *
 * @param {() => void} [onClick] - Handler for button click
 * @returns {JSX.Element} The rendered SchedulesManageScheduleButton component
 */
const SchedulesManageScheduleButton = React.memo(
  function SchedulesManageScheduleButton({
    onClick,
  }: SchedulesManageScheduleButtonProps) {
    return (
      <CustomButton
        variant='text'
        color='primary'
        size='large'
        onClick={onClick}
        sx={{
          fontFamily: 'Poppins',
          fontWeight: 600,
          fontSize: '14px',
          lineHeight: '26px',
          color: '#00A5FF',
          padding: '8px 11px',
          minWidth: 'unset',
          gap: '8px',
          '&:hover': {
            backgroundColor: 'transparent',
          },
          '& .MuiButton-endIcon': {
            marginLeft: '8px',
          },
        }}
        endIcon={
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
          >
            <path
              d='M4.25067 5.61C6.27067 8.2 10.0007 13 10.0007 13V19C10.0007 19.55 10.4507 20 11.0007 20H13.0007C13.5507 20 14.0007 19.55 14.0007 19V13C14.0007 13 17.7207 8.2 19.7407 5.61C20.2507 4.95 19.7807 4 18.9507 4H5.04067C4.21067 4 3.74067 4.95 4.25067 5.61Z'
              fill='#00A5FF'
            />
          </svg>
        }
      >
        Gerir Escala
      </CustomButton>
    );
  },
);

export default SchedulesManageScheduleButton;
